import { graphql } from 'src/graphql';

export const FetchFigmaAuthStatus = graphql(`
  query FetchFigmaAuthStatus {
    viewerFigmaAuthStatus
  }
`);
